/**
 * Tint token -> accent text-color class. Shared by sections that color an
 * accent by tint ("blue" resolves to cerulean, matching IconChip).
 *
 * @type {Record<"blue" | "azure" | "coral" | "cobalt" | "teal", string>}
 */
export const tintTextClass = {
  blue: "text-cerulean",
  azure: "text-azure",
  coral: "text-coral",
  cobalt: "text-cobalt",
  teal: "text-teal-deep",
};
